import { EPlatformFeature } from '@enums/campaign.enum';
import { TranslateService } from '@ngx-translate/core';
import { ICtaAnalyticsData } from '../../cta-analytics-table.interface';
import { IDeliverableCard } from '../cta-analytics-details-deliverable-card/cta-analytics-details-deliverable-card.interface';
import { BaseAnalyticsFormatter } from './base-analytics-formatter';

export class TwitchStreamAnalyticsFormatter extends BaseAnalyticsFormatter {
  constructor(execution: ICtaAnalyticsData, translate: TranslateService) {
    super(EPlatformFeature.twitchStream, execution, translate);
  }

  public generateDeliverableCardData(): IDeliverableCard[] {
    const title = this.processTitle();
    const gameplay = this.processGamePlay();
    const chatbot = this.processChatbot();
    const chatbotMulti = this.processChatbotMulti();
    const talkingPoints = this.processTalkingPoints();
    const talkingPointAis = this.processTalkingPointAis();
    const visual = this.processVisual();
    const productPlacements = this.processProductPlacements();
    const showcase = this.processShowcase();
    const custom = this.processCustom();
    const textTracking = this.processTextTracking();
    const audioTracking = this.processAudioTracking();

    return [
      ...(title ?? []),
      ...(gameplay ?? []),
      ...(chatbot ?? []),
      ...(chatbotMulti ?? []),
      ...(talkingPoints ?? []),
      ...(talkingPointAis ?? []),
      ...(visual ?? []),
      ...(productPlacements ?? []),
      ...(showcase ?? []),
      ...(custom ?? []),
      ...(textTracking ?? []),
      ...(audioTracking ?? []),
    ];
  }
}
